"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateEditorWrap = exports.FilterDateWrap = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const styled_1 = require("../styled");
exports.FilterDateWrap = styled_components_1.default.div `
  display: flex;
  margin-right: 8px;
`;
exports.DateEditorWrap = (0, styled_components_1.default)(styled_1.FilterInputWrap) `
  margin: 0 8px;
  flex: 1;
  background: var(--lowestBg);
  .ant-picker {
    width: 100%;
    background: var(--lowestBg);
    border: none;
    input {
      color: var(--firstLevelText);
    }
  }
  .ant-picker-range {
    border: none !important;
    .ant-picker-separator {
      color: var(--firstLevelText);
    }
  }
`;
